import React from 'react';

const HiringPartners = () => {
  const partnerImagesRow1 = [
    { file: 'HP-1.png', alt: 'EY' },
    { file: 'HP-2.png', alt: 'Goldman Sachs' },
    { file: 'HP-3.png', alt: 'LTIMindtree' },
    { file: 'HP-4.png', alt: 'Diageo' },
    { file: 'HP-5.png', alt: 'Allstate' },
    { file: 'HP-6.png', alt: 'Rippling' },
    { file: 'HP-7.png', alt: 'Manipal Hospitals' },
    { file: 'HP-10.png', alt: 'SBI Securities' },
    { file: 'HP-12.png', alt: 'HDFC Ergo' },
    { file: 'HP-13.png', alt: 'Quess' },
    { file: 'HP-15.png', alt: 'Lenskart' },
    { file: 'HP-16.png', alt: 'TeamLease Services' },
    { file: 'HP-17.png', alt: 'Sutherland' },
    { file: 'HP-18.png', alt: 'NoBroker' },
    { file: 'HP-19.png', alt: 'HexaHealth' },
    { file: 'HP-21.png', alt: 'Fincare' },
    { file: 'HP-22.png', alt: 'CarDekho' },
    { file: 'HP-23.png', alt: 'Infinity Learn' }
  ];

  const partnerImagesRow2 = [
    { file: 'HP-24.png', alt: 'Accenture' },
    { file: 'HP-25.png', alt: 'PlanetSpark' },
    { file: 'HP-26.png', alt: 'Russell Tobin' },
    { file: 'HP-28.png', alt: 'Equinity' },
    { file: 'HP-29.png', alt: 'HP' },
    { file: 'HP-33.png', alt: 'Jaro Education' },
    { file: 'HP-34.png', alt: 'Bambinos' },
    { file: 'HP-35.png', alt: 'Teleperformance' },
    { file: 'HP-36.png', alt: 'Intellipaat' },
    { file: 'HP-37.png', alt: 'Concentrix' },
    { file: 'HP-38.png', alt: 'Jio' },
    { file: 'HP-39.png', alt: 'Ttec' },
    { file: 'HP-40.png', alt: 'AML' },
    { file: 'HP-41.png', alt: 'Codeyoung' },
    { file: 'HP-42.png', alt: 'PhonePe' },
    { file: 'HP-43.png', alt: 'Redancy' },
    { file: 'HP-44.png', alt: 'Bhanzu' },
    { file: 'HP-45.png', alt: 'Bajaj' }
  ];

  return (
    <section className="hiring-partners-section" id="hiring-partners">
      <div className="partners-container">
        <div className="section-header">
          <h2 className="section-title">
            Our Reputed <span>Hiring Partners</span>
          </h2>
          <p className="section-subtitle">
            500+ top hiring partners recruit Online Manipal MBA graduates for leadership and management roles
          </p>
        </div>

        <div className="slider-wrapper">
          {/* Track 1 - Sliding Left */}
          <div className="slider-track-container">
            <div className="slider-track slide-left">
              {[...partnerImagesRow1, ...partnerImagesRow1].map((img, idx) => (
                <div className="slide-card" key={`row1-${idx}`}>
                  <img
                    src={`/uploads/${img.file}`}
                    alt={img.alt}
                    loading="lazy"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Track 2 - Sliding Right */}
          <div className="slider-track-container mt-4">
            <div className="slider-track slide-right">
              {[...partnerImagesRow2, ...partnerImagesRow2].map((img, idx) => (
                <div className="slide-card" key={`row2-${idx}`}>
                  <img
                    src={`/uploads/${img.file}`}
                    alt={img.alt}
                    loading="lazy"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HiringPartners;
